var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLandline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0_4979_36555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22101 11.045C9.35869 11.1082 9.51381 11.1227 9.6608 11.086C9.8078 11.0492 9.9379 10.9636 10.0297 10.843L10.2663 10.533C10.3905 10.3674 10.5516 10.233 10.7367 10.1404C10.9219 10.0479 11.126 9.99967 11.333 9.99967H13.333C13.6866 9.99967 14.0258 10.1402 14.2758 10.3902C14.5259 10.6402 14.6663 10.9794 14.6663 11.333V13.333C14.6663 13.6866 14.5259 14.0258 14.2758 14.2758C14.0258 14.5259 13.6866 14.6663 13.333 14.6663C10.1504 14.6663 7.09816 13.4021 4.84773 11.1516C2.59729 8.90119 1.33301 5.84894 1.33301 2.66634C1.33301 2.31272 1.47348 1.97358 1.72353 1.72353C1.97358 1.47348 2.31272 1.33301 2.66634 1.33301H4.66634C5.01996 1.33301 5.3591 1.47348 5.60915 1.72353C5.8592 1.97358 5.99967 2.31272 5.99967 2.66634V4.66634C5.99967 4.87333 5.95148 5.07749 5.85891 5.26263C5.76634 5.44777 5.63194 5.60881 5.46634 5.73301L5.15434 5.96701C5.03195 6.06046 4.94569 6.1934 4.9102 6.34324C4.87472 6.49308 4.8922 6.65059 4.95967 6.78901C5.87079 8.63958 7.36929 10.1362 9.22101 11.045Z",
    stroke: "currentColor ",
    strokeOpacity: 0.9,
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4979_36555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLandline);
export default __webpack_public_path__ + "static/media/phone-landline.18d387ec667cb712c18e3056162c2050.svg";
export { ForwardRef as ReactComponent };